import { useState } from "react";
import { useReveal } from "@/hooks/useReveal";
import { Gift, LayoutGrid, Wand2, ShoppingBag } from "lucide-react";

const CARDS = [
  {
    icon: Gift,
    title: "Бонусы",
    text: "Получайте бонусы за регистрацию, покупки и участие в программе привилегий.",
  },
  {
    icon: LayoutGrid,
    title: "Каталог",
    text: "Все модели, размеры и актуальные цены всегда под рукой.",
  },
  {
    icon: Wand2,
    title: "ИИ-примерка",
    text: "Посмотрите, как выбранная модель будет выглядеть именно на вас.",
  },
  {
    icon: ShoppingBag,
    title: "Новинки",
    text: "Новые коллекции появляются в клубе раньше социальных сетей.",
  },
];

const VIP_IMAGES = [
  { src: "/media/vip-chest.png", alt: "Сундук с бонусами Angiolini" },
  { src: "/media/vip-catalog.png", alt: "Каталог Angiolini" },
  { src: "/media/vip-mirror.png", alt: "ИИ-примерка Angiolini" },
  { src: "/media/vip-gift.png", alt: "Подарок Angiolini" },
];

export const WhyApp = () => {
  const ref = useReveal();
  const [active, setActive] = useState(0);

  return (
    <section id="why" ref={ref} data-testid="why-section" className="relative py-28 md:py-36 overflow-hidden" style={{ background: "var(--paper)" }}>
      <div
        className="hidden lg:block absolute top-20 right-[5%] w-[380px] h-[400px] pointer-events-none"
        style={{ perspective: "1100px" }}
        data-testid="vip-object-stage"
      >
        {VIP_IMAGES.map((img, i) => (
          <img
            key={i}
            src={img.src}
            alt={img.alt}
            className={`vip-obj ${active === i ? "is-active" : ""}`}
          />
        ))}
      </div>

      <div className="pw-container relative">
        <span className="pw-eyebrow reveal">Клуб привилегий</span>
        <h2 className="pw-h2 reveal mt-6 max-w-3xl">
          Почему тысячи покупателей начинают именно с приложения?
        </h2>
        <p className="reveal mt-8 max-w-2xl text-base md:text-lg leading-relaxed" style={{ color: "var(--grey-1)" }}>
          Покупка верхней одежды — это не только примерка. Хочется заранее узнать
          цены, посмотреть коллекции, понять, какие модели подходят именно вам, и
          не пропустить лучшие новинки. Поэтому мы создали пространство Angiolini —
          место, где всё начинается ещё до визита в бутик.
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-16">
          {CARDS.map((c, i) => (
            <div
              key={i}
              data-testid={`why-card-${i}`}
              onMouseEnter={() => setActive(i)}
              className="reveal group p-8 rounded-2xl border transition-colors duration-300 hover:border-black/40"
              style={{ background: "#ffffff", borderColor: "var(--grey-3)", transitionDelay: `${i * 90}ms` }}
            >
              <c.icon size={24} strokeWidth={1.5} style={{ color: "var(--ink)" }} />
              <h3 className="mt-7 text-lg font-semibold" style={{ letterSpacing: "-0.02em" }}>
                {c.title}
              </h3>
              <p className="mt-3 text-[14px] leading-relaxed" style={{ color: "var(--grey-1)" }}>
                {c.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
